import { constants } from '../constants/global.constants';

export const projectActions = {
    selectProject
};

function selectProject(projectId) {
    return (dispatch, getState) => {
        return dispatch({
            type: constants.SELECT_PROJECT,
            selectedProjectId: projectId,
               
        });
    };
}


// WEBPACK FOOTER //
// ./src/actions/project.actions.js